<template>
  <div>
    <div class="title">案由管理</div>
    <div class="container">
      <span>案由类型：</span>
      <el-input
        v-model="menuname"
        placeholder="请输入案由"
        style="width:200px;margin-left:10px;margin-right:10px"
      ></el-input>
      <el-button type="primary" @click="query" v-if="searchShow">
        <i class="el-icon-search"></i>
        查询
      </el-button>
      <el-button class="all" @click="reset" v-if="resetShow">重置</el-button>
      <el-button type="primary" @click="addbtn" v-if="addNewShow">
        <i class="el-icon-plus"></i>
        新建
      </el-button>
      <div class="tablemain">
        <el-table :data="tableData" style="width: 100%" border>
          <el-table-column prop="typeName" label="案由类型"></el-table-column>
          <el-table-column prop="address" label="操作" width="180">
            <template slot-scope="scope">
              <div>
                <span style="margin-right:10px;cursor:pointer" @click="edit(scope.row)" v-if="editShow">修改</span>
                <span style="margin-right:10px;cursor:pointer" @click="deletebtn(scope.row)" v-if="deleteShow">删除</span>
                <span style="cursor:pointer" @click="openquestion(scope.row)" v-if="qusetionShow">问题</span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationmain">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalpage"
            @current-change="operatesizechange"
            :current-page.sync="pageNum"
            hide-on-single-page
          ></el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :visible.sync="addVisible"
      title="新建案由类型"
      width="400px"
      :show-close="false"
      top="10vh"
    >
      <div slot="title">
        <p>新建案由类型</p>
        <i class="el-icon-error" @click="addVisible = false" style="cursor:pointer"></i>
      </div>
      <el-input v-model="que" placeholder="请输入案由类型名称" style="width:100%"></el-input>
      <div slot="footer" class="dialogBtn">
        <el-button @click="addVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="changeVisible"
      title="修改案件类型"
      width="400px"
      :show-close="false"
      top="10vh"
    >
      <div slot="title">
        <p>修改案件类型</p>
        <i class="el-icon-error" @click="changeVisible = false" style="cursor:pointer"></i>
      </div>
      <el-input v-model="changeque" placeholder="请输入案件类型名称" style="width:100%"></el-input>
      <div slot="footer" class="dialogBtn">
        <el-button @click="changeVisible = false">取 消</el-button>
        <el-button type="primary" @click="changesubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="changequeVisible"
      title="修改模板问题"
      width="400px"
      :show-close="false"
      top="10vh"
    >
      <div slot="title">
        <p>修改模板问题</p>
        <i class="el-icon-error" @click="changequeVisible = false" style="cursor:pointer"></i>
      </div>
      <el-input v-model="changequecontent" placeholder="请输入询问名称" style="width:100%"></el-input>
      <div slot="footer" class="dialogBtn">
        <el-button @click="changequeVisible = false">取 消</el-button>
        <el-button type="primary" @click="changequesubmit">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :visible.sync="questionlistvisible"
      title="问题管理"
      width="800px"
      :show-close="false"
      top="10vh"
    >
      <div slot="title">
        <p>问题管理</p>
        <i class="el-icon-error" @click="questionlistvisible = false" style="cursor:pointer"></i>
      </div>
      <el-button type="primary" @click="addquestsubmit" class="addquest" v-if="addNewQShow">新建问题</el-button>
      <el-table :data="qusetionData" style="width: 100%" border>
        <el-table-column prop="sort" label="序号" width="60px" align="center"></el-table-column>
        <el-table-column prop="content" label="询问内容"></el-table-column>
        <el-table-column prop="recordId" label="关联案由">
          <template>
            <div>{{quecasename}}</div>
          </template>
        </el-table-column>

        <el-table-column prop="address" label="操作" width="100">
          <template slot-scope="scope">
            <div>
              <span style="margin-right:10px;cursor:pointer" @click="editquebtn(scope.row)">修改</span>
              <span style="margin-right:10px;cursor:pointer" @click="deletequebtn(scope.row)">删除</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="sort" label="排序" width="90px" align="center">
          <template slot-scope="scope">
            <img
              src="../images/up.png"
              class="updownimg"
              @click="todown(scope.row)"
              v-if="scope.$index!==0"
            />
            <img
              src="../images/down.png"
              class="updownimg"
              @click="toup(scope.row)"
              v-if="scope.$index!==questlength"
            />
            <!-- <img
              src="../images/uptop.png"
              class="adddelimg"
              @click="addbutton(item)"
              v-if="scope.row.sort!==1"
            />-->
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>

    <el-drawer title="添加询问内容" :visible.sync="drawer" size="500px">
      <div style="padding:20px">
        <span class="questtitle">询问内容：</span>
        <el-input v-model="questname" placeholder="请输入询问内容" style="width:100%"></el-input>
        <span class="questtitle">关联案件：</span>
        <el-input v-model="glcase" placeholder="请输入关联案件" style="width:100%" disabled></el-input>
        <span class="questtitle" v-if="sortShow">排序：</span>
        <el-input v-model="order" placeholder="请输入排序" style="width:100%" disabled></el-input>
        <el-button type="primary" @click="addquestinfo" class="addquest" style="margin-top:20px">确认</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  getcaselist,
  addcase,
  deletecase,
  changecase,
  getquestionlist,
  addquestion,
  deletequestion,
  changequestion,
  movetemplateQuestion
} from "../axios/api.js";
export default {
  data() {
    return {
      questname: "",
      order: "",
      pageNum: 1,
      pageSize: 10,
      questlength: 0,
      glcase: "",
      tableData: [
        {
          date: "违反医疗纠纷预防和处理规定"
        }
      ],
      qusetionData: [],
      addVisible: false,
      changeVisible: false,
      changequeVisible: false,
      questionlistvisible: false,
      drawer: false,
      menuname: "",
      que: "",
      changeque: "",
      quecasename: "",
      changequecontent: "",
      searchShow:false,
      addNewShow:false,
      resetShow:false,
      editShow:false,
      deleteShow:false,
      qusetionShow:false,
      addNewQShow:false,
      sortShow:false
    };
  },
  methods: {
    btnShow(){
      const arr = localStorage.getItem("permissionList")
      var newArr=JSON.parse(arr.replace(/\n/g,"\\n").replace(/\r/g,"\\r")).filter(i=>i.type==="B");
      newArr.forEach(el => {
        if (el.id=='21') {
          this.searchShow=true
        } if (el.id=='22') {
          this.resetShow=true
        } if (el.id=='23') {
          this.addNewShow=true
        } if (el.id=='24') {
          this.editShow=true
        } if (el.id=='25') {
          this.deleteShow=true
        } if (el.id=='26') {
          this.qusetionShow=true
        } if (el.id=='27') {
          this.addNewQShow=true
        } if (el.id=='28') {
          this.sortShow=true
        }
      });
      // console.log(newArr);
    },
    //向上排序
    todown(e) {
      var questionlist = this.qusetionData;
      for (var i in questionlist) {
        if (e.sort === questionlist[i].sort) {
          questionlist[i].sort = questionlist[i].sort - 1;
        } else {
          if (questionlist[i].sort === e.sort - 1) {
            questionlist[i].sort = questionlist[i].sort + 1;
          }
        }
      }
      console.log(questionlist);
      this.qusetionData = questionlist.sort(function(a, b) {
        return a.sort < b.sort ? -1 : 1;
      });

      movetemplateQuestion(this.qusetionData).then(res => {
        if (res && res.code === 200) {
          this.$message.success("排序成功");
        }
      });
    },

    //向下排序
    toup(e) {
      // console.log(e.sort);
      this.esort = e.sort;
      var questionlist = this.qusetionData;
      console.log(questionlist);
      // var arr = [];
      for (var i in questionlist) {
        console.log(this.esort);
        if (this.esort === questionlist[i].sort) {
          console.log(1);
          console.log(questionlist[i].sort);
          questionlist[i].sort = questionlist[i].sort + 1;
          // console.log(questionlist[i].sort);
        } else {
          if (questionlist[i].sort === this.esort + 1) {
            questionlist[i].sort = questionlist[i].sort - 1;
          }
        }
      }
      console.log(questionlist);
      this.qusetionData = questionlist.sort(function(a, b) {
        return a.sort < b.sort ? -1 : 1;
      });

      movetemplateQuestion(this.qusetionData).then(res => {
        if (res && res.code === 200) {
          this.$message.success("排序成功");
        }
      });
    },

    //新建问题
    addquestsubmit() {
      this.glcase = this.quecasename;
      this.drawer = true;
      console.log(this.recordId);
    },

    //确认添加问题
    addquestinfo() {
      const params = {
        content: this.questname,
        caseTypeId: this.caseid,
        sort: this.order
      };
      if (!this.questname) {
        this.$message.error("请输入询问内容");
      } else {
        addquestion(params).then(res => {
          if (res && res.code === 200) {
            this.questname = null;
            this.order = null;
            this.$message.success("添加问题成功");
            this.drawer = false;
            this.question();
          }
        });
      }
    },
    addbtn() {
      this.addVisible = true;
    },

    //分页
    operatesizechange(e) {
      console.log(e);
      this.pageNum = e;
      this.getlist();
    },

    getlist() {
      const params = {
        keyword: this.menuname || null
      };
      getcaselist(params).then(res => {
        console.log(res.rows);
        console.log(res.data);
        var arr = [];
        for (var i in res.rows) {
          if (i < this.pageNum * 10 && i >= (this.pageNum - 1) * 10) {
            arr.push(res.rows[i]);
          }
        }

        this.tableData = arr;
        this.totalpage = res.rows.length;
      });
    },
    //查询案件
    query() {
      this.pageNum = 1;
      this.getlist();
    },
    //重置案件
    reset() {
      this.menuname = null;
      this.pageNum = 1;
      this.getlist();
    },

    //打开修改弹窗
    edit(e) {
      console.log(e);
      this.changeVisible = true;
      this.changeque = e.typeName;
      this.caseid = e.id;
    },

    //打开修改模板问题弹窗
    editquebtn(e) {
      console.log(e);
      this.changequeVisible = true;
      this.changequecontent = e.content;
      this.recordid = e.id;
    },

    //确认修改模板问题
    changequesubmit() {
      changequestion([
        this.recordid,
        this.changequecontent,
        this.recordid
      ]).then(res => {
        if (res && res.code === 200) {
          this.$message.success("模板问题修改成功");
          this.changequeVisible = false;
          this.question();
        }
      });
    },

    //打开问题列表
    openquestion(e) {
      console.log(e);
      console.log(e.recordId);
      this.questionlistvisible = true;
      this.caseid = e.id;
      this.quecasename = e.typeName;
      this.question();
    },
    //获取问题列表
    question() {
      const params = {
        caseTypeId: this.caseid
      };
      getquestionlist(params).then(res => {
        console.log(res.rows);
        this.qusetionData = res.rows;
        this.questlength = res.rows.length - 1;
        this.order = res.rows[res.rows.length - 1].sort + 1;
        console.log(this.questlength);
      });
    },

    //确认添加案件
    submitForm() {
      const params = {
        typeName: this.que
      };
      if (!this.que) {
        this.$message.error("请输入案件类型名称");
      } else {
        addcase(params).then(res => {
          if (res && res.code === 200) {
            this.que = null;
            this.$message.success("添加案件类型成功");
            this.addVisible = false;
            this.getlist();
          }
        });
      }
    },

    //确认修改案件
    changesubmit() {
      // const params = {
      //   typeName: this.changeque
      // };
      console.log(this.changeque);
      if (!this.changeque) {
        this.$message.error("请输入案件类型名称");
      } else {
        changecase([this.caseid, this.changeque, this.caseid]).then(res => {
          if (res && res.code === 200) {
            this.$message.success("案件名称修改成功");
            this.changeVisible = false;
            this.getlist();
          }
        });
      }
    },

    //删除模板问题
    deletequebtn(e) {
      console.log(e);
      this.$confirm("您确定要删除该模板问题吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            deletequestion([e.id]).then(res => {
              if (res && res.code === 200) {
                this.$message({
                  message: "删除模板问题成功",
                  type: "success"
                });
                this.question();
              }
            });
          }
        }
      });
    },
    //删除案件
    deletebtn(e) {
      console.log(e);
      this.$confirm("您确定要删除该案件吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        callback: action => {
          if (action === "confirm") {
            deletecase([e.id]).then(res => {
              if (res && res.code === 200) {
                this.$message({
                  message: "删除案件成功",
                  type: "success"
                });
                this.getlist();
              }
            });
          }
        }
      });
    }
  },
  created() {
    this.getlist();
    this.btnShow()
  }
};
</script>

<style scoped>
.updownimg {
  cursor: pointer;
}
.questtitle {
  font-size: 14px;
  font-weight: bold;
  text-align: left;
  width: 100%;
  display: inline-block;
  color: #333333;
  margin-top: 10px;
  margin-bottom: 10px;
}

.title {
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
  font-weight: bold;
}

.addquest {
  float: right;
  margin-bottom: 20px;
}

.container {
  padding: 24px;
  background: #ffffff;
  border: 1px solid #eaeaea;
  box-shadow: 0px 0px 8px 0px rgba(202, 202, 202, 0.3);
  text-align: left;
  border-radius: 3px;
  margin-top: 24px;
}

.tablemain {
  margin-top: 20px;
}
</style>